import React, { useState } from 'react';
import { Button, Icon } from '@tencent/spaui';
import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';
import dayjs from 'dayjs';
import dialog from '@/utils/dialog';
import WithPermission from '@/common/permissions/WithPermission';
import { withAccount } from '@/business-components/operator/account-context.js';
import perms from '@/common/permissions/sale/perms';
import message from '@/utils/message';

const preCheckAgencyAuth = (data) => {
  const url = getAgsApiUrl('agency', 'can-get-new-advertiser');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};

const checkCustom = (data) => {
  const url = getAgsApiUrl('agency', 'get-new-advertiser');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};

const DetailContent = (props) => (
  <div style={{ display: 'flex' }}>
    <div style={{ width: '100px', fontWeight: 'bolder' }}>查询结果</div>
    <div>
      <div style={{ fontWeight: 'bolder', paddingBottom: '4px' }}>{props.desc}</div>
      <div style={{ color: '#666' }}>
        <div>提示：其中3C、日化服饰、食品饮料、零售等行业的新客激励可累量范国为：优质客户的总消耗、以及符合优质链路消耗之和/全量消耗≥60%的客户的总消耗（如有疑问请联系渠道经理）</div>
        <div>数据更新时间为 {dayjs(props.updateTime).format('YYYY-MM-DD')}</div>
        <div>本结果为试算结果，腾讯广告保留对政策执行情况解释的权利</div>
      </div>
      <div style={{ paddingTop: '12px' }}>
        <Icon name="info-filled" color="#296bef" style={{ verticalAlign: 'text-bottom', marginRight: '4px' }}/>
        <span style={{ color: '#ff0000' }}>本部分新客查询仅供K4框/封闭框服务商查询S新客使用，不作为E赋能等其他政策的查询参考。</span>
      </div>
    </div>
  </div>
);

const CheckNewCustom = (props) => {
  const {
    companyName,
    isDialog,
  } = props;

  const grayList = props?.account?.saleStatus?.grayPermissions || [];
  const agencyId = props?.account?.saleStatus?.agencyId || 0;

  const [checkResult, setCheckResult] = useState(null);

  const check = () => {
    setCheckResult(null);
    if (!companyName) {
      message.warn('公司名称不能为空');
      return;
    }

    preCheckAgencyAuth({
      agency_id: agencyId,
    }).then((res) => {
      if (res.code !== 0 || !res?.data?.can_get) {
        message.warn('当前服务商无权查看');
        return;
      }
      checkCustom({
        agency_id: agencyId,
        enterprise_name: companyName,
      }).then((res) => {
        const {
          code,
          data,
        } = res;
        if (code !== 0) {
          dialog.confirm(<div>
            <div>skywalking_trace_id: {res.skywalking_trace_id}</div>
            <div>trace_id: {res.trace_id}</div>
          </div>, { title: '查询失败', contentStyle: { width: '600px' } });
          return;
        }

        const {
          dataDate,
          data_date,
          s_new_advertiser_tag_desc, // S政策新客标签描述
          is_s_new_advertiser, // 是否S政策新客
        } = data;

        let desc = s_new_advertiser_tag_desc;
        let date = dataDate || data_date;
        if (!is_s_new_advertiser) {
          desc = s_new_advertiser_tag_desc || '非新客';
        }

        setCheckResult({
          dataDate: date,
          desc,
        });

        if (isDialog) {
          dialog.alert(<DetailContent updateTime={date} desc={desc}/>, { title: '查询结果', contentStyle: { width: '900px' } });
        }
      });
    })
      .catch((res) => {
        const desc = res?.responseJSON?.message || '当前服务商无权查看';
        message.warn(desc);
      });
  };

  if (!grayList.includes(perms.GRAY_CHECK_NEW_CUSTOM)) {
    return null;
  }

  if (isDialog) {
    return (
      <WithPermission allOf={[perms.CHECK_NEW_CUSTOM]}>
        <div>
          <Button displayType="primary" onClick={check}>新客查询</Button>
        </div>
      </WithPermission>
    );
  }

  return (
    <WithPermission allOf={[perms.CHECK_NEW_CUSTOM]}>
      <div style={{ display: 'flex', paddingBottom: '20px' }}>
        <Button onClick={check}>新客查询</Button>
        {
          !!checkResult
            ? <div style={{ paddingLeft: '20px' }}>
              <DetailContent updateTime={checkResult?.dataDate} desc={checkResult?.desc}/>
            </div>
            : <span style={{ paddingLeft: '20px', lineHeight: '36px' }}>填写正确的公司名称即可查询</span>
        }
      </div>
    </WithPermission>
  );
};

export default withAccount(CheckNewCustom);
